import * as React from 'react'

import { Calendar, GanttChart, Map, Table, type LucideIcon } from 'lucide-react'

import ViewModes from '~/client/src/desktop/enums/ViewModes'
import ViewModeToggle, {
  IViewModeToggleOption,
} from '~/client/src/shared/components/ViewModeToggle/ViewModeToggle'
import Localization from '~/client/src/shared/localization/LocalizationManager'

const MODE_CONFIG: Record<
  ViewModes,
  { Icon: LucideIcon; getLabel: () => string }
> = {
  [ViewModes.List]: {
    Icon: Table,
    getLabel: () => Localization.translator.listView,
  },
  [ViewModes.Map]: {
    Icon: Map,
    getLabel: () => Localization.translator.mapView,
  },
  [ViewModes.Calendar]: {
    Icon: Calendar,
    getLabel: () => Localization.translator.calendarView,
  },
  [ViewModes.Gantt]: {
    Icon: GanttChart,
    getLabel: () => Localization.translator.ganttView,
  },
}

export interface IViewModeToggleGroupProps {
  value: ViewModes
  modes: ViewModes[]
  onChange: (mode: ViewModes) => void
}

const ViewModeToggleGroup: React.FC<IViewModeToggleGroupProps> = ({
  value,
  modes,
  onChange,
}) => {
  const options: IViewModeToggleOption[] = modes.map(mode => ({
    mode,
    Icon: MODE_CONFIG[mode].Icon,
    label: MODE_CONFIG[mode].getLabel(),
  }))

  return (
    <ViewModeToggle
      value={value}
      modes={options}
      onChange={mode => onChange(mode as ViewModes)}
    />
  )
}

export default ViewModeToggleGroup
